class MakezmiaRewardsLookup extends HTMLElement {
  connectedCallback() {
    this.form = this.querySelector('[data-mkz-rewards-form]');
    this.result = this.querySelector('[data-mkz-rewards-result]');
    this.endpoint = this.dataset.endpoint || '';

    if (!this.form || !this.result) return;

    this.form.addEventListener('submit', this.onSubmit.bind(this));
  }

  async onSubmit(event) {
    event.preventDefault();

    const formData = new FormData(this.form);
    const phone = String(formData.get('phone') || '').trim();

    if (!phone) {
      this.showResult('Enter your mobile number to check reward points.');
      return;
    }

    if (!this.endpoint) {
      this.showResult(
        'Your reward account will be linked with this mobile number after order confirmation. OTP balance lookup will be active once the rewards backend is connected.'
      );
      return;
    }

    this.showResult('Checking your rewards...');

    try {
      const response = await fetch(`${this.endpoint}?phone=${encodeURIComponent(phone)}`, {
        headers: { Accept: 'application/json' },
      });

      if (!response.ok) throw new Error('Reward lookup failed');

      const data = await response.json();
      const balance = Number(data.balance || 0);
      this.showResult(`Available reward balance: ₹${balance.toLocaleString('en-IN')}. Verify OTP to redeem at checkout.`);
    } catch (error) {
      this.showResult('Reward lookup is temporarily unavailable. Please try again later or contact Makezmia support.');
    }
  }

  showResult(message) {
    this.result.textContent = message;
    this.result.classList.add('is-visible');
  }
}

if (!customElements.get('makezmia-rewards-lookup')) {
  customElements.define('makezmia-rewards-lookup', MakezmiaRewardsLookup);
}

function openMakezmiaOtpLogin(event) {
  const trigger = event?.target?.closest?.('[data-mkz-otp-login]') || null;
  if (window.simplyOtp?.customer) return true;

  event?.preventDefault?.();
  event?.stopPropagation?.();
  event?.stopImmediatePropagation?.();

  const openOtpPopup = () => {
    if (window.simplyOtp?.initializeSimplyOtp && window.simplyOtp?.openPopup) {
      window.simplyOtp.initializeSimplyOtp();
      window.simplyOtp.openPopup();
      return true;
    }

    const rewardsLogin = document.querySelector('.mkz-rewards-card__link.show-sotp-popup');
    if (rewardsLogin && rewardsLogin !== trigger) {
      rewardsLogin.click();
      return true;
    }

    return false;
  };

  if (trigger?.closest?.('.cart-drawer')) {
    closeNativeCartDrawer();
    window.setTimeout(openOtpPopup, 160);
    return false;
  }

  openOtpPopup();

  return false;
}

window.mkzOpenOtpLogin = openMakezmiaOtpLogin;

document.addEventListener('click', (event) => {
  const trigger = event.target.closest('[data-mkz-otp-login]');
  if (!trigger) return;

  openMakezmiaOtpLogin(event);
}, true);

const rewardStateKey = 'mkzRewardRedeem';
const fastrrCouponStateKey = 'fastrrCouponCode';
let mkzCartProcessingFallbackTimer = null;

function setMkzCartProcessing(isProcessing, message = 'Updating cart...', fallbackMs = 0) {
  document.querySelectorAll('[data-mkz-cart-processing-text]').forEach((text) => {
    text.textContent = message;
  });

  document.querySelectorAll('cart-items-component').forEach((component) => {
    component.classList.toggle('cart-items-disabled', Boolean(isProcessing));
  });

  window.clearTimeout(mkzCartProcessingFallbackTimer);
  if (isProcessing && fallbackMs > 0) {
    mkzCartProcessingFallbackTimer = window.setTimeout(() => {
      setMkzCartProcessing(false);
    }, fallbackMs);
  }
}

function getCurrentRewardInput() {
  return document.querySelector('[data-mkz-reward-redeem]');
}

function readSavedReward() {
  const savedReward = localStorage.getItem(rewardStateKey);
  if (!savedReward) return null;

  try {
    const parsedReward = JSON.parse(savedReward);
    const input = getCurrentRewardInput();
    const currentCustomerId = input?.dataset?.customerId || '';

    if (!parsedReward?.discountCode) return null;
    if (!input || !currentCustomerId) {
      localStorage.removeItem(rewardStateKey);
      localStorage.removeItem(fastrrCouponStateKey);
      return null;
    }

    if (parsedReward.customerId !== currentCustomerId) {
      localStorage.removeItem(rewardStateKey);
      localStorage.removeItem(fastrrCouponStateKey);
      return null;
    }

    return parsedReward;
  } catch (error) {
    localStorage.removeItem(rewardStateKey);
    localStorage.removeItem(fastrrCouponStateKey);
    return null;
  }
}

function getSavedRewardDiscountCode() {
  return readSavedReward()?.discountCode || '';
}

function isRewardCustomerLoggedIn() {
  const rewardCard = document.querySelector('[data-mkz-rewards-customer]');
  const rewardInput = getCurrentRewardInput();

  return rewardCard?.dataset?.mkzRewardsCustomer === 'true' || Boolean(rewardInput?.dataset?.customerId);
}

function syncFastrrRewardCoupon(discountCode) {
  if (discountCode) {
    localStorage.setItem(fastrrCouponStateKey, discountCode);
  } else {
    localStorage.removeItem(fastrrCouponStateKey);
  }
}

function getSavedRewardAmount() {
  const savedReward = readSavedReward();
  const points = Number(savedReward?.points || 0);

  if (!Number.isFinite(points)) return 0;

  return Math.max(0, Math.round(points));
}

function isMakezmiaRewardCode(code) {
  return String(code || '').startsWith('MKZ-RWD-');
}

function formatRewardRupees(amount) {
  return `₹${Math.max(0, Math.round(Number(amount) || 0)).toLocaleString('en-IN')}`;
}

function formatRewardRupeesWithDecimals(amount) {
  return `₹${Math.max(0, Number(amount) || 0).toLocaleString('en-IN', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  })}`;
}

function parseRewardRupees(text) {
  const value = Number(String(text || '').replace(/[^\d.]/g, ''));

  return Number.isFinite(value) ? value : 0;
}

function getShiprocketSmartCartMerchandiseTotal(root) {
  if (!root) return 0;

  const itemPrices = Array.from(root.querySelectorAll('.mini-cart-item-wrapper .display-price-container'));
  const total = itemPrices.reduce((sum, element) => sum + parseRewardRupees(element.textContent), 0);

  return Number.isFinite(total) ? total : 0;
}

function getShiprocketSmartCartRoot() {
  return document.querySelector('#shiprocket-smart-cart-root')?.shadowRoot || null;
}

function rememberSmartCartText(element) {
  if (!element || element.dataset.mkzOriginalText) return;

  element.dataset.mkzOriginalText = element.textContent || '';
}

function setSmartCartText(element, text) {
  if (!element || element.textContent === text) return;

  element.textContent = text;
}

function restoreShiprocketSmartCartRewardDisplay(root = getShiprocketSmartCartRoot()) {
  if (!root) return;

  root.getElementById('mkz-smart-cart-reward-line')?.remove();
  root.querySelectorAll('[data-mkz-original-text]').forEach((element) => {
    setSmartCartText(element, element.dataset.mkzOriginalText || '');
    delete element.dataset.mkzOriginalText;
  });
}

function installShiprocketSmartCartRewardStyle(root) {
  if (!root || root.getElementById('mkz-smart-cart-reward-style')) return;

  const style = document.createElement('style');
  style.id = 'mkz-smart-cart-reward-style';
  style.textContent = `
    #mkz-smart-cart-reward-line {
      display: flex;
      align-items: center;
      justify-content: space-between;
      gap: 12px;
      margin: 6px 0 0;
      color: #12813d;
      font-size: 13px;
      line-height: 1.25;
    }

    #mkz-smart-cart-reward-line .mkz-smart-cart-reward-value {
      font-weight: 700;
      white-space: nowrap;
    }
  `;
  root.appendChild(style);
}

function syncShiprocketSmartCartRewardDisplay() {
  const root = getShiprocketSmartCartRoot();
  if (!root) return;

  if (shiprocketSmartCartObserver && !root.__mkzRewardObserverAttached) {
    Object.defineProperty(root, '__mkzRewardObserverAttached', { value: true });
    shiprocketSmartCartObserver.observe(root, {
      childList: true,
      subtree: true,
      characterData: true,
    });
  }

  const rewardAmount = getSavedRewardAmount();

  if (!rewardAmount) {
    restoreShiprocketSmartCartRewardDisplay(root);
    return;
  }

  installShiprocketSmartCartRewardStyle(root);

  const summary = root.querySelector('.mini-cart-order-summary');
  const mrpDiscountRow = root.querySelector('#sr-cart-discount-code-discount-mrp-container');
  const totalValue = root.querySelector('.sr-cart-total-price-amount .total-price')
    || root.querySelector('.sr-cart-total-price-amount');
  const savingBadges = root.querySelectorAll('.combined-offer-badge b');
  const itemPriceElements = Array.from(root.querySelectorAll('.mini-cart-item-wrapper .display-price-container'));

  let rewardLine = root.getElementById('mkz-smart-cart-reward-line');
  if (!rewardLine && summary) {
    rewardLine = document.createElement('p');
    rewardLine.id = 'mkz-smart-cart-reward-line';
    rewardLine.innerHTML = '<span>Reward points</span><span class="mkz-smart-cart-reward-value"></span>';
    if (mrpDiscountRow) {
      mrpDiscountRow.insertAdjacentElement('afterend', rewardLine);
    } else {
      summary.appendChild(rewardLine);
    }
  }

  const rewardValue = rewardLine?.querySelector('.mkz-smart-cart-reward-value');
  if (rewardValue) setSmartCartText(rewardValue, `-${formatRewardRupees(rewardAmount)}`);

  if (totalValue) {
    rememberSmartCartText(totalValue);
    const merchandiseTotal = getShiprocketSmartCartMerchandiseTotal(root);
    const originalTotal = parseRewardRupees(totalValue.dataset.mkzOriginalText || totalValue.textContent);
    const merchandiseIncludesReward = merchandiseTotal > 0 && Math.abs((merchandiseTotal + rewardAmount) - originalTotal) <= 1;
    const totalAlreadyMatchesRewardedItems = merchandiseTotal > 0 && originalTotal > 0 && Math.abs(merchandiseTotal - originalTotal) <= 1;
    const nextTotal = merchandiseIncludesReward
      ? merchandiseTotal
      : totalAlreadyMatchesRewardedItems
        ? originalTotal
      : Math.max(0, (originalTotal || merchandiseTotal) - rewardAmount);

    setSmartCartText(totalValue, formatRewardRupees(nextTotal));

    if (merchandiseIncludesReward && itemPriceElements.length === 1) {
      const itemPrice = itemPriceElements[0];
      if (!itemPrice.dataset.mkzOriginalText) {
        itemPrice.dataset.mkzOriginalText = formatRewardRupeesWithDecimals(merchandiseTotal + rewardAmount);
      }
    }
  }

  savingBadges.forEach((badge) => {
    rememberSmartCartText(badge);
    const originalSaving = parseRewardRupees(root.querySelector('#sr-cart-discount-code-discount-mrp')?.textContent)
      || parseRewardRupees(badge.dataset.mkzOriginalText || badge.textContent);
    setSmartCartText(badge, String(Math.max(0, Math.round(originalSaving + rewardAmount))));
  });
}

let shiprocketSmartCartObserver = null;
let shiprocketSmartCartSyncTimer = null;
let cartDrawerMoneyObserver = null;
let cartDrawerMoneyNormalizeTimer = null;
let mkzRewardClearingAfterCartChange = false;

function scheduleShiprocketSmartCartRewardDisplaySync() {
  window.clearTimeout(shiprocketSmartCartSyncTimer);
  shiprocketSmartCartSyncTimer = window.setTimeout(syncShiprocketSmartCartRewardDisplay, 80);
}

function startShiprocketSmartCartRewardObserver() {
  if (shiprocketSmartCartObserver) return;

  shiprocketSmartCartObserver = new MutationObserver(scheduleShiprocketSmartCartRewardDisplaySync);
  shiprocketSmartCartObserver.observe(document.documentElement, {
    childList: true,
    subtree: true,
  });

  scheduleShiprocketSmartCartRewardDisplaySync();
}

function normalizeCartDrawerMoney(root = document) {
  const drawers = root.matches?.('.cart-drawer') ? [root] : Array.from(root.querySelectorAll?.('.cart-drawer') || []);

  drawers.forEach((drawer) => {
    const walker = document.createTreeWalker(drawer, NodeFilter.SHOW_TEXT, {
      acceptNode(node) {
        const parent = node.parentElement;
        if (!parent || ['SCRIPT', 'STYLE', 'TEXTAREA', 'INPUT'].includes(parent.tagName)) {
          return NodeFilter.FILTER_REJECT;
        }

        return /(?:Rs\.|₹)\s*[\d,]+\.00\b/.test(node.nodeValue)
          ? NodeFilter.FILTER_ACCEPT
          : NodeFilter.FILTER_REJECT;
      },
    });

    const nodes = [];
    while (walker.nextNode()) {
      nodes.push(walker.currentNode);
    }

    nodes.forEach((node) => {
      node.nodeValue = node.nodeValue.replace(/(-?\s*(?:Rs\.|₹)\s*[\d,]+)\.00\b/g, '$1');
    });
  });
}

function scheduleCartDrawerMoneyNormalize() {
  window.clearTimeout(cartDrawerMoneyNormalizeTimer);
  cartDrawerMoneyNormalizeTimer = window.setTimeout(() => normalizeCartDrawerMoney(), 50);
}

function startCartDrawerMoneyObserver() {
  if (cartDrawerMoneyObserver) return;

  cartDrawerMoneyObserver = new MutationObserver(scheduleCartDrawerMoneyNormalize);
  cartDrawerMoneyObserver.observe(document.documentElement, {
    childList: true,
    subtree: true,
    characterData: true,
  });

  scheduleCartDrawerMoneyNormalize();
}

function getCartSectionIds() {
  const sectionIds = new Set();

  document.querySelectorAll('cart-items-component[data-section-id]').forEach((component) => {
    if (component.dataset.sectionId) sectionIds.add(component.dataset.sectionId);
  });

  return Array.from(sectionIds);
}

function dispatchCartDiscountUpdate(cart) {
  document.dispatchEvent(new CustomEvent('discount:update', {
    bubbles: true,
    detail: {
      resource: cart,
      sourceId: 'mkz-rewards',
      data: {
        sections: cart?.sections || {},
      },
    },
  }));
}

function installFastrrRewardCouponBridge() {
  if (window.__mkzFastrrRewardCouponBridgeInstalled || typeof window.fetch !== 'function') return;

  const nativeFetch = window.fetch.bind(window);
  window.__mkzFastrrRewardCouponBridgeInstalled = true;

  window.fetch = async (...args) => {
    const response = await nativeFetch(...args);

    try {
      const request = args[0];
      const init = args[1] || {};
      const requestUrl = typeof request === 'string' ? request : request?.url || '';
      const method = String(init.method || request?.method || 'GET').toUpperCase();
      const parsedUrl = new URL(requestUrl, window.location.origin);
      const discountCode = getSavedRewardDiscountCode();

      if (
        method !== 'GET'
        || !discountCode
        || parsedUrl.origin !== window.location.origin
        || parsedUrl.pathname !== '/cart.js'
        || !response.ok
      ) {
        return response;
      }

      const cart = await response.clone().json();
      const existingDiscounts = Array.isArray(cart.discounts) ? cart.discounts : [];
      const existingDiscountCodes = Array.isArray(cart.discount_codes) ? cart.discount_codes : [];
      const headers = new Headers(response.headers);
      headers.set('Content-Type', 'application/json; charset=utf-8');

      cart.discounts = [
        { code: discountCode },
        ...existingDiscounts.filter((discount) => discount?.code !== discountCode),
      ];
      cart.discount_codes = [
        { code: discountCode, applicable: true },
        ...existingDiscountCodes.filter((discount) => discount?.code !== discountCode),
      ];
      cart.attributes = {
        ...(cart.attributes || {}),
        MakezmiaRewardsRedeem: 'true',
        MakezmiaRewardCode: discountCode,
      };

      return new Response(JSON.stringify(cart), {
        status: response.status,
        statusText: response.statusText,
        headers,
      });
    } catch (error) {
      return response;
    }
  };
}

installFastrrRewardCouponBridge();

function buildFastrrFallbackUrl(products, isCart = false) {
  if (!Array.isArray(products) || products.length === 0) return '/checkout';

  const cartPath = products
    .map((product) => `${product.variantId}:${product.quantity || 1}`)
    .join(',');

  return `/cart/${cartPath}${isCart ? '' : '?checkout=true'}`;
}

function getSelectedProductForm(button) {
  return button.closest('form[action*="/cart/add"]') || document.querySelector('form[action*="/cart/add"]');
}

async function buildFastrrProductCheckoutPayload(button) {
  const form = getSelectedProductForm(button);
  if (!form) return null;

  const formData = new FormData(form);
  const variantId = String(formData.get('id') || '');
  const quantity = Math.max(1, Number(formData.get('quantity') || 1));
  const productResponse = await fetch(`${window.location.pathname}.js`, {
    headers: { Accept: 'application/json' },
  });

  if (!productResponse.ok) return null;

  const product = await productResponse.json();
  const variant = Array.isArray(product.variants)
    ? product.variants.find((item) => String(item.id) === variantId)
    : null;

  if (!variant || variant.available === false) return null;

  const productPayload = {
    productId: product.id,
    title: variant.name || product.title,
    variantId: variant.id,
    variantTitle: variant.public_title ? variant.title : '',
    price: Number((Number(variant.price || 0) / 100).toFixed(2)),
    quantity,
    image: variant.featured_image?.src || product.media?.[0]?.src || product.featured_image || '',
    item_meta_data: {
      properties: variant.properties || {},
    },
    customAttributes: {},
    vendor: product.vendor,
    product_type: product.type,
  };

  return {
    type: 'product',
    products: [productPayload],
    fallbackUrl: buildFastrrFallbackUrl([productPayload]),
  };
}

async function buildFastrrCartCheckoutPayload() {
  const cartResponse = await fetch('/cart.js', {
    headers: { Accept: 'application/json' },
  });

  if (!cartResponse.ok) return null;

  const cart = await cartResponse.json();
  const products = Array.isArray(cart.items)
    ? cart.items.map((item) => ({
      productId: item.product_id,
      title: item.title || item.product_title,
      variantId: item.variant_id,
      variantTitle: item.product_has_only_default_variant ? '' : item.variant_title,
      price: Number((Number(item.price || 0) / 100).toFixed(2)),
      quantity: item.quantity > 0 ? item.quantity : 1,
      image: item.image,
      optionsArr: item.product_has_only_default_variant ? [] : item.options_with_values,
      item_meta_data: {
        properties: item.properties || {},
      },
      customAttributes: item.properties || {},
      vendor: item.vendor,
      product_type: item.type,
    }))
    : [];

  if (products.length === 0) return null;

  return {
    type: 'cart',
    products,
    fallbackUrl: buildFastrrFallbackUrl(products, true),
    cartAttributes: {
      ...(cart.attributes || {}),
      shopifyCartToken: cart.token,
    },
  };
}

async function openFastrrCheckoutWithReward(button, discountCode) {
  if (typeof window.shiprocketCheckoutDirectHandler !== 'function') return false;

  const isCartCheckout = button.matches('[data-type="cart"].shiprocket-headless')
    || Boolean(button.closest('[data-type="cart"].shiprocket-headless'))
    || window.location.pathname === '/cart';
  const payload = isCartCheckout
    ? await buildFastrrCartCheckoutPayload()
    : await buildFastrrProductCheckoutPayload(button);

  if (!payload) return false;

  syncFastrrRewardCoupon(discountCode);
  window.shiprocketCheckoutDirectHandler({
    ...payload,
    couponCode: discountCode,
    cartAttributes: {
      ...(payload.cartAttributes || {}),
      MakezmiaRewardsRedeem: 'true',
      MakezmiaRewardCode: discountCode,
    },
  });
  if (payload.type === 'cart') {
    closeNativeCartDrawer();
  }

  return true;
}

function isFastrrPanelOpen() {
  return Boolean(document.getElementById('fastrr-main-container') || document.getElementById('headless-container'));
}

function closeFastrrPanel() {
  document.getElementById('fastrr-main-container')?.remove();
  document.getElementById('headless-container')?.remove();
  document.body.style.overflow = 'auto';
  document.body.style.height = '';
  document.querySelectorAll('.sr-headless-checkout').forEach((button) => {
    button.removeAttribute('disabled');
    button.style.opacity = '';
  });
}

function resetNativeCartDrawerState(dialog = document.querySelector('.cart-drawer__dialog')) {
  if (!dialog) return;

  if (dialog.open) return;

  dialog.classList.remove('dialog-closing');
  document.documentElement.removeAttribute('scroll-lock');
  document.body.style.width = '';
  document.body.style.position = '';
  document.body.style.top = '';
}

function closeNativeCartDrawer() {
  const drawerDialog = document.querySelector('.cart-drawer__dialog[open]');
  const drawerComponent = drawerDialog?.closest('cart-drawer-component');
  const drawerCloseButton = drawerDialog?.querySelector('.cart-drawer__close-button');

  if (drawerCloseButton) {
    drawerCloseButton.click();
    window.setTimeout(() => resetNativeCartDrawerState(drawerDialog), 280);
    return;
  }

  if (drawerComponent && typeof drawerComponent.close === 'function') {
    drawerComponent.close();
  } else if (drawerDialog && typeof drawerDialog.close === 'function') {
    drawerDialog.close();
  }

  drawerDialog?.removeAttribute('open');
  document.body.classList.remove('overflow-hidden');
  document.documentElement.classList.remove('overflow-hidden');
  window.setTimeout(() => resetNativeCartDrawerState(drawerDialog), 0);
}

async function refreshOpenFastrrCartPanel(discountCode = '') {
  if (!isFastrrPanelOpen() || typeof window.shiprocketCheckoutDirectHandler !== 'function') return;

  const payload = await buildFastrrCartCheckoutPayload();
  if (!payload) return;

  closeFastrrPanel();
  window.shiprocketCheckoutDirectHandler({
    ...payload,
    couponCode: discountCode || null,
    cartAttributes: {
      ...(payload.cartAttributes || {}),
      MakezmiaRewardsRedeem: discountCode ? 'true' : '',
      MakezmiaRewardCode: discountCode || '',
    },
  });
}

async function openFastrrCartCheckout(button) {
  if (typeof window.shiprocketCheckoutDirectHandler !== 'function') return false;

  const payload = await buildFastrrCartCheckoutPayload();
  if (!payload) return false;

  const discountCode = getSavedRewardDiscountCode();
  syncFastrrRewardCoupon(discountCode);

  closeNativeCartDrawer();
  await new Promise((resolve) => window.setTimeout(resolve, 80));

  window.shiprocketCheckoutDirectHandler({
    ...payload,
    couponCode: discountCode || null,
    cartAttributes: {
      ...(payload.cartAttributes || {}),
      MakezmiaRewardsRedeem: discountCode ? 'true' : '',
      MakezmiaRewardCode: discountCode || '',
    },
  });

  return true;
}

async function updateCartRewardDiscount(discountCode, shouldApply) {
  const cartResponse = await fetch('/cart.js', {
    headers: { Accept: 'application/json' },
  });
  const cart = await cartResponse.json();
  const existingCodes = getExistingCartDiscountCodes(cart);
  const nonRewardCodes = existingCodes.filter((code) => !isMakezmiaRewardCode(code));
  const sectionIds = getCartSectionIds();
  const nextCodes = shouldApply
    ? Array.from(new Set([...nonRewardCodes, discountCode]))
    : nonRewardCodes;

  const response = await fetch('/cart/update.js', {
    method: 'POST',
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({
      discount: nextCodes.join(','),
      ...(sectionIds.length > 0 && {
        sections: sectionIds.join(','),
        sections_url: window.location.pathname,
      }),
      attributes: {
        MakezmiaRewardsRedeem: shouldApply ? 'true' : '',
        MakezmiaRewardCode: shouldApply ? discountCode : '',
      },
    }),
  });

  if (!response.ok) throw new Error('Unable to update cart discount');

  const data = await response.json();
  const appliedDiscount = Array.isArray(data.discount_codes)
    ? data.discount_codes.find((discount) => discount.code === discountCode)
    : null;

  if (shouldApply && appliedDiscount && appliedDiscount.applicable === false && Number(data.item_count || 0) > 0) {
    throw new Error('Reward discount code is not applicable');
  }

  return data;
}

async function createRewardDiscount(input) {
  const endpoint = input.dataset.rewardEndpoint || '';
  const customerId = input.dataset.customerId || '';
  const fallbackDiscountCode = input.dataset.discountCode || '';
  const fallbackPoints = input.dataset.points || '0';

  if (!endpoint) {
    return {
      discountCode: fallbackDiscountCode,
      points: fallbackPoints,
    };
  }

  if (!customerId) {
    throw new Error('Customer login is required');
  }

  const cartResponse = await fetch('/cart.js', {
    headers: { Accept: 'application/json' },
  });
  const cart = await cartResponse.json();

  const response = await fetch(endpoint, {
    method: 'POST',
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({
      customer_id: customerId,
      cart_total: Number(cart.items_subtotal_price || cart.original_total_price || cart.total_price || 0),
    }),
  });

  const data = await response.json().catch(() => ({}));
  if (!response.ok || !data.code) {
    const detailMessage = Array.isArray(data.details)
      ? data.details.map((detail) => detail?.message).filter(Boolean).join(', ')
      : '';
    throw new Error(detailMessage || data.error || 'Unable to create reward discount');
  }

  return {
    discountCode: data.code,
    points: String(data.points || fallbackPoints),
  };
}

async function applySavedRewardDiscount() {
  const parsedReward = readSavedReward();
  const input = getCurrentRewardInput();

  if (!parsedReward?.discountCode) return null;

  if (!input) {
    syncFastrrRewardCoupon(parsedReward.discountCode);
    return updateCartRewardDiscount(parsedReward.discountCode, true);
  }

  try {
    const rewardDiscount = await createRewardDiscount(input);
    const discountCode = rewardDiscount.discountCode;
    const points = String(rewardDiscount.points || input.dataset.points || parsedReward.points || '0');
    const customerId = input.dataset.customerId || parsedReward.customerId || '';

    input.checked = true;
    input.dataset.points = points;
    input.dataset.appliedDiscountCode = discountCode;
    setRewardRedeemLabel(input, points);
    setRewardStatus(input, `${points} reward points selected. Discount updated for this cart.`);
    localStorage.setItem(rewardStateKey, JSON.stringify({ discountCode, points, customerId }));
    syncFastrrRewardCoupon(discountCode);

    return updateCartRewardDiscount(discountCode, true);
  } catch (error) {
    localStorage.removeItem(rewardStateKey);
    input.checked = false;
    input.dataset.appliedDiscountCode = '';
    syncFastrrRewardCoupon('');
    setRewardStatus(input, error.message || 'Reward discount is not active for this cart yet.', true);

    return updateCartRewardDiscount('', false);
  }
}

function getExistingCartDiscountCodes(cart) {
  const codes = [];

  if (Array.isArray(cart.discount_codes)) {
    cart.discount_codes.forEach((discount) => {
      if (discount?.code) codes.push(discount.code);
    });
  }

  if (Array.isArray(cart.cart_level_discount_applications)) {
    cart.cart_level_discount_applications.forEach((discount) => {
      if (discount?.title) codes.push(discount.title);
    });
  }

  if (Array.isArray(cart.items)) {
    cart.items.forEach((item) => {
      if (!Array.isArray(item.line_level_discount_allocations)) return;

      item.line_level_discount_allocations.forEach((allocation) => {
        const title = allocation?.discount_application?.title;
        if (title) codes.push(title);
      });
    });
  }

  return Array.from(new Set(codes));
}

function getRewardDiscountCodes(cart) {
  return getExistingCartDiscountCodes(cart).filter(isMakezmiaRewardCode);
}

async function clearRewardDiscountsForGuest() {
  if (isRewardCustomerLoggedIn()) return null;

  localStorage.removeItem(rewardStateKey);
  syncFastrrRewardCoupon('');

  const cartResponse = await fetch('/cart.js', {
    headers: { Accept: 'application/json' },
  });
  if (!cartResponse.ok) return null;

  const cart = await cartResponse.json();
  const rewardCodes = getRewardDiscountCodes(cart);
  if (rewardCodes.length === 0) return null;

  const sectionIds = getCartSectionIds();
  const nextCodes = getExistingCartDiscountCodes(cart).filter((code) => !isMakezmiaRewardCode(code));

  setMkzCartProcessing(true, 'Removing reward discount...', 9000);

  let response;

  try {
    response = await fetch('/cart/update.js', {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        discount: nextCodes.join(','),
        ...(sectionIds.length > 0 && {
          sections: sectionIds.join(','),
          sections_url: window.location.pathname,
        }),
        attributes: {
          MakezmiaRewardsRedeem: '',
          MakezmiaRewardCode: '',
        },
      }),
    });
  } finally {
    setMkzCartProcessing(false);
  }

  if (!response.ok) return null;

  const updatedCart = await response.json();
  dispatchCartDiscountUpdate(updatedCart);
  scheduleCartDrawerMoneyNormalize();
  scheduleShiprocketSmartCartRewardDisplaySync();

  return updatedCart;
}

function resetRewardInputsAfterCartChange(message = '') {
  document.querySelectorAll('[data-mkz-reward-redeem]').forEach((input) => {
    input.checked = false;
    input.disabled = false;
    input.dataset.appliedDiscountCode = '';
    if (message) setRewardStatus(input, message);
  });
}

async function clearRewardDiscountsAfterCartChange() {
  if (mkzRewardClearingAfterCartChange) return null;

  const savedReward = readSavedReward();
  const cartResponse = await fetch('/cart.js', {
    headers: { Accept: 'application/json' },
  });
  if (!cartResponse.ok) return null;

  const cart = await cartResponse.json();
  const rewardCodes = getRewardDiscountCodes(cart);

  if (!savedReward && rewardCodes.length === 0) {
    resetRewardInputsAfterCartChange();
    return null;
  }

  mkzRewardClearingAfterCartChange = true;
  localStorage.removeItem(rewardStateKey);
  syncFastrrRewardCoupon('');
  resetRewardInputsAfterCartChange('Cart changed. Apply reward points again for the updated total.');
  setMkzCartProcessing(true, 'Removing reward points...', 9000);

  try {
    const updatedCart = await updateCartRewardDiscount('', false);
    dispatchCartDiscountUpdate(updatedCart);
    scheduleShiprocketSmartCartRewardDisplaySync();
    scheduleCartDrawerMoneyNormalize();
    await refreshOpenFastrrCartPanel('');

    return updatedCart;
  } finally {
    mkzRewardClearingAfterCartChange = false;
    setMkzCartProcessing(false);
  }
}

function setRewardStatus(input, message, isError = false) {
  const card = input.closest('[data-mkz-rewards-card]');
  const status = card?.querySelector('[data-mkz-reward-status]');
  if (!status) return;

  status.textContent = message;
  status.classList.toggle('is-error', isError);
  status.classList.add('is-visible');
}

function setRewardRedeemLabel(input, points) {
  const label = input.closest('label');
  const text = label?.querySelector('.mkz-rewards-card__redeem-text');
  if (!text || !points) return;

  text.textContent = `Redeem ${points} reward points`;
}

document.addEventListener('change', async (event) => {
  const input = event.target.closest('[data-mkz-reward-redeem]');
  if (!input) return;

  const savedReward = readSavedReward();
  let savedDiscountCode = '';
  let savedPoints = input.dataset.points || '0';
  const customerId = input.dataset.customerId || '';
  const appliedDiscountCode = input.dataset.appliedDiscountCode || '';

  if (savedReward) {
    savedDiscountCode = savedReward?.discountCode || '';
    savedPoints = savedReward?.points || savedPoints;
  }

  let discountCode = input.checked ? '' : (appliedDiscountCode || savedDiscountCode || input.dataset.discountCode || '');
  let points = input.checked ? (input.dataset.points || '0') : savedPoints;

  if (!input.checked && !discountCode) {
    input.checked = false;
    setRewardStatus(input, 'Reward discount code is not configured yet.', true);
    return;
  }

  input.disabled = true;
  setRewardStatus(input, input.checked ? 'Applying reward points...' : 'Removing reward points...');
  setMkzCartProcessing(true, input.checked ? 'Applying reward points...' : 'Removing reward points...');

  try {
    if (input.checked) {
      const rewardDiscount = await createRewardDiscount(input);
      discountCode = rewardDiscount.discountCode;
      points = rewardDiscount.points;
    }

    if (!discountCode) {
      throw new Error('Reward discount code is not configured yet.');
    }

    const updatedCart = await updateCartRewardDiscount(discountCode, input.checked);

    if (input.checked) {
      localStorage.setItem(rewardStateKey, JSON.stringify({ discountCode, points, customerId }));
      input.dataset.points = points;
      input.dataset.appliedDiscountCode = discountCode;
      setRewardRedeemLabel(input, points);
      syncFastrrRewardCoupon(discountCode);
      setRewardStatus(input, `${points} reward points applied.`);
    } else {
      localStorage.removeItem(rewardStateKey);
      input.dataset.appliedDiscountCode = '';
      syncFastrrRewardCoupon('');
      setRewardStatus(input, 'Reward points removed from this order.');
    }

    dispatchCartDiscountUpdate(updatedCart);
    scheduleShiprocketSmartCartRewardDisplaySync();
    await refreshOpenFastrrCartPanel(input.checked ? discountCode : '');
    scheduleShiprocketSmartCartRewardDisplaySync();
  } catch (error) {
    if (input.checked) {
      input.checked = false;
      localStorage.removeItem(rewardStateKey);
      syncFastrrRewardCoupon('');
      setRewardStatus(input, error.message || 'Could not apply reward points. Please try again.', true);
      scheduleShiprocketSmartCartRewardDisplaySync();
    } else {
      input.checked = false;
      localStorage.removeItem(rewardStateKey);
      syncFastrrRewardCoupon('');
      setRewardStatus(input, 'Could not remove reward points. Please try again.', true);
      scheduleShiprocketSmartCartRewardDisplaySync();
    }
  } finally {
    input.disabled = false;
    setMkzCartProcessing(false);
  }
});

document.addEventListener('click', (event) => {
  const cartUpdateTrigger = event.target.closest(
    '.cart-drawer__dialog .quantity-plus, .cart-drawer__dialog .quantity-minus, .cart-drawer__dialog .cart-items__remove button'
  );

  if (!cartUpdateTrigger || cartUpdateTrigger.disabled) return;

  setMkzCartProcessing(true, 'Updating cart...', 9000);
}, true);

document.addEventListener('cart:update', async (event) => {
  if (event.detail?.data?.didError) return;

  scheduleCartDrawerMoneyNormalize();

  try {
    const cleanedCart = await clearRewardDiscountsForGuest();
    if (cleanedCart) return;

    await clearRewardDiscountsAfterCartChange();
  } catch (error) {
  }
});

document.addEventListener('submit', (event) => {
  const form = event.target;
  if (!(form instanceof HTMLFormElement)) return;
  if (!form.matches('form[action*="/cart/add"]')) return;

  window.setTimeout(async () => {
    try {
      await clearRewardDiscountsAfterCartChange();
    } catch (error) {
    }
  }, 900);
}, true);

document.addEventListener('click', async (event) => {
  const cartCloseButton = event.target.closest('[data-mkz-cart-close]');
  if (cartCloseButton) {
    event.preventDefault();
    event.stopPropagation();
    event.stopImmediatePropagation();
    closeNativeCartDrawer();
    return;
  }

  const fastrrCartButton = event.target.closest('[data-mkz-fastrr-cart-checkout]');
  if (fastrrCartButton) {
    event.preventDefault();
    event.stopPropagation();
    event.stopImmediatePropagation();

    fastrrCartButton.disabled = true;

    try {
      const didOpen = await openFastrrCartCheckout(fastrrCartButton);
      if (!didOpen) {
        window.location.href = '/checkout';
      }
    } catch (error) {
      window.location.href = '/checkout';
    } finally {
      fastrrCartButton.disabled = false;
    }

    return;
  }

  const button = event.target.closest('.sr-headless-checkout, [data-type="cart"].shiprocket-headless');
  if (!button) return;
  if (button.dataset.mkzRewardCheckoutBypass === 'true') {
    delete button.dataset.mkzRewardCheckoutBypass;
    return;
  }

  const discountCode = getSavedRewardDiscountCode();
  if (!discountCode) return;

  installFastrrRewardCouponBridge();
  syncFastrrRewardCoupon(discountCode);

  try {
    event.preventDefault();
    event.stopPropagation();
    event.stopImmediatePropagation();

    const didOpen = await openFastrrCheckoutWithReward(button, discountCode);
    if (!didOpen) {
      button.dataset.mkzRewardCheckoutBypass = 'true';
      window.setTimeout(() => {
        button.click();
      }, 0);
    }
  } catch (error) {
    button.dataset.mkzRewardCheckoutBypass = 'true';
    window.setTimeout(() => {
      button.click();
    }, 0);
  }
}, true);

document.addEventListener('DOMContentLoaded', () => {
  startShiprocketSmartCartRewardObserver();
  startCartDrawerMoneyObserver();

  const parsedReward = readSavedReward();
  const inputs = document.querySelectorAll('[data-mkz-reward-redeem]');

  inputs.forEach((input) => {
    const appliedDiscountCode = input.dataset.appliedDiscountCode || '';
    if (appliedDiscountCode.startsWith('MKZ-RWD-')) {
      input.checked = true;
      localStorage.setItem(rewardStateKey, JSON.stringify({
        discountCode: appliedDiscountCode,
        points: input.dataset.points || '0',
        customerId: input.dataset.customerId || '',
      }));
      syncFastrrRewardCoupon(appliedDiscountCode);
    }
  });

  clearRewardDiscountsForGuest().catch(() => {});

  if (!parsedReward) return;

  inputs.forEach((input) => {
    if (parsedReward.discountCode.startsWith('MKZ-RWD-') && !input.dataset.appliedDiscountCode) {
      input.checked = false;
      localStorage.removeItem(rewardStateKey);
      syncFastrrRewardCoupon('');
    }
  });
});

startShiprocketSmartCartRewardObserver();
startCartDrawerMoneyObserver();
